import { apiClient } from "../services/axiosInstance";
import { ServerListResponse, ServerSingleResponse } from "../types";

export type List = {
  entity_type: "List";
  id: number;
  display_name: string;
  description?: string;
  is_public: boolean;
  list_type_id: number;
  slug: string;
  create_time: string;
  update_time: string;
  total_items?: number;
  list_items?: Array<{
    comic_id?: number;
    release_id?: number;
    [key: string]: any;
  }>;
  // Computed properties for convenience
  name?: string; // Alias for display_name
  list_type?: "comics" | "releases"; // Derived from list_type_id
};

export type CreateListPayload = {
  name: string;
  description?: string;
  is_public?: boolean;
  list_type?: "comics" | "releases";
};

export type AddToListsPayload = {
  list_ids: number[];
};

export type AddToListsResult = {
  list_id: number;
  success: boolean;
  message?: string;
};

export function getComicLists() {
  return apiClient.get<ServerListResponse<List>>("/v1/lists/comics");
}

export function getReleaseLists() {
  return apiClient.get<ServerListResponse<List>>("/v1/lists/releases");
}

export function postCreateComicList(payload: CreateListPayload) {
  return apiClient.post<ServerSingleResponse<List>>("/v1/lists/create", {
    meta: [],
    payload: { ...payload, list_type: "comics" },
  });
}

export function postCreateReleaseList(payload: CreateListPayload) {
  return apiClient.post<ServerSingleResponse<List>>("/v1/lists/create", {
    meta: [],
    payload: { ...payload, list_type: "releases" },
  });
}

export function postAddComicToLists(
  comicId: number,
  payload: AddToListsPayload,
) {
  return apiClient.post<ServerSingleResponse<AddToListsResult[]>>(
    `/v1/lists/add-to-lists`,
    { 
      meta: [], 
      payload: { 
        entity_type: "comic", 
        entity_id: comicId, 
        list_ids: payload.list_ids 
      } 
    },
  );
}

export function postAddReleaseToLists(
  releaseId: number,
  payload: AddToListsPayload,
) {
  return apiClient.post<ServerSingleResponse<AddToListsResult[]>>(
    `/v1/lists/add-to-lists`,
    { 
      meta: [], 
      payload: { 
        entity_type: "release", 
        entity_id: releaseId, 
        list_ids: payload.list_ids 
      } 
    },
  );
}

export function postRemoveComicFromList(
  comicId: number,
  listId: number,
) {
  return apiClient.post<ServerSingleResponse<{ success: boolean; message: string }>>(
    `/v1/lists/remove-from-list`,
    { 
      meta: [], 
      payload: { 
        entity_id: comicId, 
        list_id: listId 
      } 
    },
  );
}

export function postRemoveReleaseFromList(
  releaseId: number,
  listId: number,
) {
  return apiClient.post<ServerSingleResponse<{ success: boolean; message: string }>>(
    `/v1/lists/remove-from-list`,
    { 
      meta: [], 
      payload: { 
        entity_id: releaseId, 
        list_id: listId 
      } 
    },
  );
}

export function getList(listId: number) {
  return apiClient.get<ServerSingleResponse<List>>(`/v1/lists/${listId}`);
}

export function postDeleteComicList(listId: number) {
  return apiClient.post<ServerSingleResponse<{ success: boolean; message: string }>>(
    `/v1/lists/delete`,
    { meta: [], payload: { list_id: listId } },
  );
}

export function postDeleteReleaseList(listId: number) {
  return apiClient.post<ServerSingleResponse<{ success: boolean; message: string }>>(
    `/v1/lists/delete`,
    { meta: [], payload: { list_id: listId } },
  );
}
